import React from 'react';

import PageTitleNew from '../../ui/PageTitleNew';
import Context from './Context';
import NewButton from './New/Button';
import Table from './Table';

export default function Index() {
  return (
    <Context>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Affiliate Training Steps" />

        <div className="ibox-content mt20">
          <NewButton />
          <Table />
        </div>
      </div>
    </Context>
  );
}
